import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { TermsOfUsePdfComponent } from './terms-of-use-pdf.component';
import { FcpLinkModule } from 'fc-ui-components';

const components = [TermsOfUsePdfComponent];

@NgModule({
    declarations: components,
    imports: [CommonModule, TranslateModule, FcpLinkModule],
    exports: components
})
export class TermsOfUsePdfModule {}
